import { SET_FILTER_OPTIONS, SET_USER_FILTER } from "../actions/types";

const initialState = {
  options: {},
  userOption: {},
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_OPTIONS: {
      return {
        ...state,
        options: action.data,
      };
    }
    case SET_USER_FILTER: {
      return {
        ...state,
        userOption: { ...state.userOption, ...action.data },
      };
    }
    default:
      return state;
  }
};

export default filterReducer;
